<!-- Translated: yes -->
<template>
  <span class="component">
    <icon :name="icon" />
  </span>
</template>

<script>
export default {
  props: [
    'current',
  ],
  computed: {
    icon() {
      return [
        'sort-down',
        'sort',
        'sort-up',
      ][this.current + 1];
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component
  display inline-block

</style>



// WEBPACK FOOTER //
// TableSortIndicator.vue?3ef42341